<template>
<div class="mx-auto" style="max-width: 400px">
  <v-card class="IMThemeGray rounded-xl rounded-tl-0">
    <v-card-title class="IMThemeOrange rounded-xl py-2 text-white rounded-tl-0 justify-content-center">
      {{ id == -1 ? "إضافة" : "تعديل" }}
    </v-card-title>
    <v-card-text>
        <v-form
            ref="cityForm"
            v-model="valid"
        >
            <label for="storeName">اسم المحافظة</label>
            <v-text-field
                id="storeName"
                v-model="cityForm.name"
                class="rounded-tl-0"
                rounded
                dense
                :rules="cityName"
                solo
            ></v-text-field>
            <div class="text-center">
                <v-btn
                    @click="SubmitSetCity()"
                    rounded
                    class="rounded-tl-0 px-8"
                    :disabled="!valid"
                >
                    تم
                </v-btn>
            </div>
            <div class="pt-3 text-center">
                <router-link to="-1" v-if="id != -1">
                    <v-btn
                    outlined
                    rounded
                    color="white"
                    class="rounded-tl-0 px-8"
                    >
                    إلغاء التحديد
                    </v-btn>
                </router-link>
            </div>
        </v-form>
    </v-card-text>
  </v-card>
</div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    id: String,
  },
  data:() => ({
      valid: false,
      cityName: [
          v => !!v || 'يرجى كتابة اسم مدينة'
      ]
  }),
  mounted() {
    if (this.id != -1) {
      this.fetchCityForm(this.id);
    } else {
      this.$refs.cityForm.reset();
    }
  },
  computed: {
    ...mapGetters(["cityForm"]),
  },
  methods: {
    ...mapActions(["fetchCityForm", "setCity"]),
    SubmitSetCity() {
      this.setCity(this.cityForm);
      this.$refs.cityForm.reset();
      if (this.id != -1) {
        this.$router.push("./-1");
      }
    },
  },
  watch: {
    id(newId) {
      if (newId != -1) {
        this.fetchCityForm(this.id);
      } else {
        this.$refs.cityForm.reset();
      }
    },
  },
};
</script>
